import { BaseWorkflowActivityAssignmentViewModel } from "../base-workflow-activity-assignment";
import { autoinject, computedFrom } from "aurelia-framework";
import { WorkflowAssignmentsService } from "../../../../services/workflow/workflow-assignments-service";
import { DialogClientService } from "@rightship-tech/common-ui/services/basic/dialog-client.service";
import { I18N } from "aurelia-i18n";
import { VettingService } from "../../../../services/vetting/vetting.service";

@autoinject()
export class ActivityAssignment extends BaseWorkflowActivityAssignmentViewModel {
    disableAutoComplete: boolean = true;

    constructor(workflowAssignmentsService: WorkflowAssignmentsService, dialogClientService: DialogClientService,
        i18n: I18N, vetClientService: VettingService) {
            super(dialogClientService, i18n, workflowAssignmentsService, vetClientService);
    }

    @computedFrom('_model')
    public get comment() {
        return this.assignment && this.assignment.remarks;
    }

    @computedFrom('_model')
    public get commentBy() {
        return this.assignment && this.assignment.actionTaker;
    }

    @computedFrom('_model')
    public get commentByFullName() {
        return this.assignment.meta && JSON.parse(this.assignment.meta).commentByFullName;
    }

    @computedFrom('_model')
    public get commentedOn() {
        return this.assignment && this.assignment.creationDate;
    }

    onActivated() {
        this.assignment.assignmentState.actionTakerAnonText = 'Comment';
    }
}
